import React from "react"
import "./App.css"
import RootRouter from "navigation/RootRouter"
import { checkExistingSession, SessionDataStore } from "helpers/authUtils"
import { useQuery } from "react-query"
import Loader from "components/Shared/Loader"
import { authorization } from "helpers/authorizationUtils"

function App() {
	document.title = "Phronesis"
	const isSessionStillAlive = async () => {
		const authenticateData = await checkExistingSession()
		SessionDataStore.getInstance().save(authenticateData)
		const { success, features } = await authorization(authenticateData.roles)
		if (success) {
			SessionDataStore.getInstance().setFeatures(features)
		}
		return true
	}

	const { isLoading } = useQuery("checkExistingSession", isSessionStillAlive, {
		refetchOnWindowFocus: false,
		retry: false,
	})

	return isLoading ? <Loader position={100} height={110} /> : <RootRouter />
}

export default App
